<template>
    <div class="mt-3 text-right text-xs text-gray-500">
        <a
            :href="post.cover?.attributionLink ?? ''"
            target="_blank"
            class="hover:text-gray-700"
        >
            {{ post.cover?.attributionText }}
        </a>
    </div>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'

    interface BlogPostCoverAttributionProps {
        post: CMSArticle
    }

    defineProps<BlogPostCoverAttributionProps>()
</script>
